import { Scanner, type IDetectedBarcode } from "@yudiel/react-qr-scanner";

interface QrScanProps {
  onScan: (value: string) => void;
}

export function QrScan({ onScan }: QrScanProps) {
  return (
    <Scanner
      onScan={(detectedCodes: IDetectedBarcode[]) => {
        onScan(detectedCodes[0].rawValue);
      }}
      onError={console.error}
      sound={false}
    />
  );
}
